import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  ActionList,
  BlockStack,
  Box,
  Button,
  Card,
  Collapsible,
  Divider,
  Icon,
  InlineStack,
  Text,
} from "@shopify/polaris";

// import helper
import { baseHelper, storageHelper } from "lib/helpers";

// config
import { PrivateBrandingContext, PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import appConfig from "configuration";
import quickSettingConfig from "app/reports/provider/widgets/quickSetting/quickSettingConfig";
import { useLocation, useNavigate } from "react-router-dom";
import quickLink from "./quickLinkConfig";

const { brandPageV2URL } = appConfig; // brandPageURL

const ProviderQuickLink = (props) => {
  const { link: actionLink = [] } = props;
  const { cms, currentUser } = useContext(PrivateContext);

  const {
    branding: { isHideMc },
  } = useContext(PrivateBrandingContext);

  const { pathname: path } = useLocation();
  const navigate = useNavigate();
  const { config, title } = quickSettingConfig(cms);

  const [openActionLink, setActive] = useState(true);
  const [actionLinkExpanded, setExpanded] = useState(false);
  const handleToggle = useCallback(() => setActive((link) => !link), []);
  const [hideMcDetails, setHideMcDetails] = useState(storageHelper.get(constant.HIDE_DETAILS));

  useEffect(() => {
    if (typeof isHideMc === "undefined") {
      return;
    }
    if (isHideMc !== hideMcDetails) {
      setHideMcDetails(isHideMc);
    }
  }, [hideMcDetails, isHideMc]);

  const currentUserContext = {
    brandName: currentUser.brandName,
    // domain: brandPageURL,
    domain: brandPageV2URL,
    shop: currentUser.shop,
    token: storageHelper.get(constant.TOKEN),
  };

  const actionCard = (action) => {
    if (hideMcDetails && action.link && action.link === "/contact-us") {
      return false;
    }
    if (action.isHide) {
      return false;
    }
    const onAction = (action.action && action.action.bind(currentUserContext)) || (() => navigate(action.link));

    return (
      // <ActionList
      //   sections={[
      //     {
      //       items: [
      //         {
      //           content: action.label,
      //           helpText: action.caption,
      //           icon: action.icon,
      //           onAction,
      //         },
      //       ],
      //     },
      //   ]}
      // />
      <div onClick={onAction} className="button-clone">
        <InlineStack align="start" blockAlign="center" gap="200" wrap={false}>
          <Box width="20px">
            <Icon source={action.icon} color="base" />
          </Box>
          <BlockStack>
            <Text id="link-text-custom" fontWeight="bold">
              {action.label}
            </Text>
            <Text tone="subdued" as="p" variant="bodySm" breakWord>
              {action.caption}
            </Text>
          </BlockStack>
        </InlineStack>
      </div>
    );
  };

  const getQuickLinks = (links = []) => {
    let updatedActions = [...links];
    if (currentUser.ecommercePlatform) {
      updatedActions = updatedActions.filter((item) => item.id !== "exportOrder");
    }
    return updatedActions.map((link) => actionCard(link));
  };

  const getQuickSettings = (settings = []) => {
    return settings.map((setting) => actionCard(setting));
  };

  const quickLinkConfig = quickLink(cms);
  const quickActions = (actionLink.length && actionLink) || quickLinkConfig[path];

  return (
    <Card>
      <InlineStack blockAlign="center" align="space-between">
        <Text variant="headingSm" as="h1">
          {constant.ACTION}
        </Text>
        <Button
          variant="plain"
          disclosure={actionLinkExpanded ? constant.DOWN : constant.UP}
          onClick={() => {
            handleToggle();
            setExpanded(!actionLinkExpanded);
          }}
        >
          {actionLinkExpanded ? constant.SHOW : baseHelper.ucFirst(constant.HIDE)}
        </Button>
      </InlineStack>

      <Collapsible
        open={openActionLink}
        id="collapsibleQuickLink"
        transition={{ duration: "150ms", timingFunction: "ease" }}
      >
        <br />
        <BlockStack gap="400">{getQuickLinks(quickActions)}</BlockStack>
        <br />
        <Divider />
        <br />
        {/* {config[path] && (
            <Card.Section subdued title={title[path] || cms("common.actions.title.setting")}>
              {getQuickSettings(config[path])}
            </Card.Section>
          )} */}
        {config[path] && (
          <>
            <Text fontWeight="bold">{title[path] || cms("common.actions.title.setting")}</Text>
            <br />
            <BlockStack gap="400">{getQuickSettings(config[path])}</BlockStack>
          </>
        )}
      </Collapsible>
    </Card>
  );
};

export default ProviderQuickLink;
